import React, { useState, useEffect, useRef } from 'react';
import { bannerAPI, imagaeAPI } from '../../services/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';


const AddBanner = () => {

    const [loading, setLoading] = useState(false);
    const [loaditems, setLoadItems] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const fetchItems = async () => {

        setLoading(true);
        try {
            const res = await bannerAPI.getAll();
            setLoadItems(res.data.data); // adjust according to your API response structure
        } catch (error) {
            console.error("Error fetching banner:", error);
        }

        finally {
            setLoading(false); // re-enable button
        }
    };


    useEffect(() => {
        fetchItems();
    }, []);





    const [formData, setFormData] = useState({
        product_photo: null,

    });

    const photoRef = useRef(null);
    const editPhotoRef = useRef(null);


    const handleChange = (e) => {
        const { name, files } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: files[0]
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // disable button



        try {

            const data = new FormData();
            data.append("product_photo", formData.product_photo);


            const res = await bannerAPI.create(data);

            toast.success('Banner added successfully!');
            setFormData({ product_photo: null });
            if (photoRef.current) photoRef.current.value = "";
            fetchItems();
        } catch (error) {
            console.error(error);
            toast.error('Error Adding Banner : ' + (error.response ? error.response.data.message : error.message));
        } finally {
            setLoading(false); // re-enable button
        }
    };


    const handleEditClick = (item) => {
        setSelectedItem(item);
        setShowEditModal(true);
    };


    const handleEditChange = (e) => {
        const { name, files } = e.target;
        setSelectedItem((prev) => ({
            ...prev,
            [name]: files[0]
        }));
    };


    const handleUpdateItem = async () => {
        setLoading(true);
        try {

            const data = new FormData();


            data.append("product_photo", selectedItem.product_photo);

            await bannerAPI.update(selectedItem.id, data);
            toast.success('Banner updated successfully!');
            setShowEditModal(false);
            fetchItems();
        } catch (error) {
            console.error(error);
            toast.error('Error Updating Banner : ' + (error.response ? error.response.data.message : error.message));
        } finally {
            setLoading(false);
        }
    };

    const confirmDelete = (id) => {
        toast.info(
            <div>
                <p className="mb-2">Are you sure you want to delete this banner?</p>
                <div className="d-flex justify-content-end">
                    <button
                        className="btn btn-sm btn-danger mr-2"
                        onClick={() => {
                            toast.dismiss();
                            handleDeleteItem(id);
                        }}
                    >
                        Yes
                    </button>
                    <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => toast.dismiss()}
                    >
                        No
                    </button>
                </div>
            </div>,
            {
                autoClose: false,
                closeOnClick: false,
                closeButton: false,
                icon: false,
            }
        );
    };


    const handleDeleteItem = async (id) => {
        setLoading(true);
        try {

            await bannerAPI.delete(id);
            toast.success("Banner deleted successfully!");
            fetchItems();
        } catch (error) {
            console.error(error);
            toast.error(
                "Error deleting banner : " +
                (error.response ? error.response.data.message : error.message)
            );
        } finally {
            setLoading(false);
        }
    };



    return (

        <>

            <div className="main-content">
                {/* Page Header */}


                <div className="content-wrapper">
                    {/* Category Creation/Edit Form */}
                    <div className="form-card">
                        <div className="form-card-header">
                            <h5 className="text-white">
                                <i className="fas fa-plus-circle me-2"></i>
                                Add Banner
                            </h5>

                        </div>
                        <div className="form-card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="form-row">
                                    <div className="form-group col-md-3">
                                        <label>Banner Upload</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            name="product_photo"
                                            onChange={handleChange}
                                            accept="image/*"
                                            ref={photoRef}
                                            required
                                        />
                                    </div>



                                </div>
                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                    {loading ? "Wait Please..." : "Add"}
                                </button>
                            </form>


                        </div>
                    </div>

                    {/* Category List */}
                    <div className="list-card">

                        <div className="category-table-container">
                            <table id="datatablebranch" className="display compact table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>SL.no</th>
                                        <th>Banner</th>


                                        <th>Edit</th>

                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loaditems.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>
                                                {item.product_photo ? (
                                                    <img
                                                        src={`${imagaeAPI}/uploads/banners/${item.product_photo}`}
                                                        alt="Product Image"
                                                        width="50"
                                                        height="50"
                                                        style={{ objectFit: "cover", cursor: "pointer" }}
                                                        onClick={() => window.open(`${imagaeAPI}/uploads/banners/${item.product_photo}`, "_blank")}
                                                    />
                                                ) : "-"}
                                            </td>


                                            <td>
                                                <a href="#" onClick={(e) => { e.preventDefault(); handleEditClick(item); }}>
                                                    <i className="fas fa-edit"></i>
                                                </a>


                                            </td>

                                            <td>

                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        confirmDelete(item.id);
                                                    }}
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <ToastContainer />
                    </div>


                </div>
            </div>

            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
                <Modal.Header>
                    <Modal.Title>Edit Banner</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {selectedItem && (
                        <form>
                            <div className="form-group">
                                <label>Banner Upload</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    name="product_photo"
                                    onChange={handleEditChange}
                                    accept="image/*"
                                    ref={editPhotoRef}
                                    required
                                />

                            </div>
                            {selectedItem.product_photo && typeof selectedItem.product_photo === 'string' && (
                                <div className="mt-2">
                                    <img src={`${imagaeAPI}/uploads/banners/${selectedItem.product_photo}`} alt="Current" width="80" />
                                    <p className="text-muted small">Current image</p>
                                </div>
                            )}
                        </form>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleUpdateItem} disabled={loading}>
                        {loading ? "Updating..." : "Update"}
                    </Button>
                </Modal.Footer>
            </Modal>


        </>

    );

};

export default AddBanner;